import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const submitLeadMagnet = (data) => api.post("/lead-magnet", data).then((r) => r.data);
export const submitNewsletter = (data) => api.post("/newsletter", data).then((r) => r.data);
export const fetchWorkshops = () => api.get("/workshops").then((r) => r.data);
export const submitWorkshopRegistration = (data) =>
  api.post("/workshop-registration", data).then((r) => r.data);
export const submitWorkshopNotify = (data) =>
  api.post("/workshop-notify", data).then((r) => r.data);
